// Enums
import { EnvName } from '@enums/environment.enum';

// Packages
import packageInfo from '../../package.json';

const scheme = 'https://';
const host   = 'wi-invoice.tpos.dev';
const port   = '';
const path   = '/api/v1';

const baseUrl = scheme + host + port + path;

export const environment = {
  production      : false,
  version         : packageInfo.version,
  appName         : 'WiInvoice',
  envName         : EnvName.STG,
  defaultLanguage : 'vi',
  apiBaseUrl      : baseUrl,
};
